import React, { useEffect, useState } from "react";
import { Wrapper } from "./ManagePermission.styled";
import {
  Row,
  Col,
  Tree,
  Select_,
  Button,
  SuccessNotification,
  ErrorNotification,
} from "components/common";
import { CarryOutOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  callGetApi,
  callPutApi,
} from "utils/api";
import { getMeCallApiWithAuthOnly } from "utils/me";

const ManagePermission = () => {
  const history = useHistory();
  let a = history.location.pathname;
  let id = a.split("/")[2];

  let options = [{ rank: 1, name: "None", id: 1 }, { rank: 2, name: "Own", id: 2 }, { rank: 3, name: "Location", id: 3 }, { rank: 4, name: "All", id: 4 }];

  const [categories, setCategories] = useState([]);
  const [formData, setFormData] = useState({});

  const handleChange = (id, e) => {
    setFormData((prev) => ({ ...prev, [id]: e }))
  };

  const SuccessPostCall = (data) => {
    SuccessNotification("Updated SuccessFul");
    setFormData({})
    getMeCallApiWithAuthOnly();
    getRoles();
  };

  const FailPostCall = () => {
    ErrorNotification("Update Call Fail.");
  };

  const handleSubmit = () => {
    callPutApi(
      `/roles/update/permissions/${id}`,
      formData,
      SuccessPostCall,
      FailPostCall
    );
  };

  const treeData = categories.map((item, itemIndex) => {
    return {
      title: (
        <div className="maintitle">
          <p>{item.category}</p>
        </div>
      ),
      key: `${itemIndex}`,
      icon: <CarryOutOutlined />,
      children: item?.permissions?.map((access, accessIndex) => {
        return {
          title: (
            <div className="sub-title">
              <p>{access?.displayName}</p>
            </div>
          ),
          key: `${access._id}`,
          icon: <CarryOutOutlined />,
          children: access?.displayFeatureName && access?.accessValue ? [{
            title: (
              <div className="text-container">
                <div className="inner-container">{access?.displayFeatureName}</div>
                <div className="input-container">
                  <Select_
                    defaultValue={access?.accessValue}
                    options={options}
                    name
                    onChange={(e) => {
                      handleChange(access._id, e);
                    }}
                  />
                </div>
              </div>
            ),
            key: `${itemIndex}-${accessIndex}`,
            icon: <CarryOutOutlined />,
          }] : []
        }
      }),
    };
  });

  const successData = (data) => {
    setCategories(data?.access);
  };
  const failData = (err) => {
    console.log(err);
  };
  const getRoles = () => {
    callGetApi(`/roles/${id}`, successData, failData);
  };
  useEffect(() => {
    getRoles();
  }, []);

  useEffect(() => {
    console.log(formData);
  }, [formData]);

  return (
    <Wrapper>
      <Row>
        <Col span={24}>
          <Tree
            defaultExpandedKeys={["0-0-0"]}
            treeData={treeData}
          />
        </Col>
        <Col style={{ display: "flex", justifyContent: "end" }} span={24}>
          <Button title="Update" onClick={handleSubmit} disabled={!Object.keys(formData).length} />
        </Col>
      </Row>
    </Wrapper>
  );
};

export default ManagePermission;
